import { ConfigProvider } from 'antd'
import EN from 'antd/es/locale/en_GB'
import SK from 'antd/es/locale/sk_SK'
import { FC } from 'react'
import { Outlet } from 'react-router-dom'
import LoadingSpinner from '../components/shared/LoadingSpinner'
import { useLanguageContext } from '../contexts/LanguageContext'
import PublicLayout from '../layouts/PublicLayout'
import { APP_LANGUAGES } from '../utils/enums'

const PublicRoutes: FC<{ hideTitle?: boolean }> = ({ hideTitle = false }) => {
	const { currentLanguage, isLanguageLoading, isInitialized } = useLanguageContext()

	// Show loading spinner while language context is initializing
	if (isLanguageLoading || !isInitialized) {
		return <LoadingSpinner />
	}

	// Select appropriate Ant Design locale based on current language
	const antdLocale = currentLanguage === APP_LANGUAGES.SK ? SK : EN

	return (
		<ConfigProvider locale={antdLocale}>
			<PublicLayout hideTitle={hideTitle}>
				<Outlet />
			</PublicLayout>
		</ConfigProvider>
	)
}

export default PublicRoutes
